import { Flow } from 'signup-constants/Flow';
import { getIsMobile } from '../utils/deviceUtils';
import { SignupEmbedder } from 'signup-embedder';
import { getIsChatBotEnabledByLanguage } from './getIsChatBotEnabledByLanguage';
export const shouldShowChatBot = ({
  flowKey
}) => {
  const isChatbotEnabledByLanguage = getIsChatBotEnabledByLanguage();

  // the flow in side panel layout shouldn't expect to show chatbot
  // Currently, only these two flows are not in side panel layout
  const allowedFlows = [Flow.HubSpotPartners, Flow.HubspotForStartups];
  return !getIsMobile() && allowedFlows.includes(flowKey) && isChatbotEnabledByLanguage && !SignupEmbedder.isActive();
};